import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import { Loading } from './loading'

export const Logout = () => {
  const { logout } = useContext(AuthContext)
  logout()
  return <Loading />
}
